module.exports = __webpack_public_path__ + "static/media/TV.aaf8baef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TV.svg
// module id = 2280
// module chunks = 7